import { lz } from "../../../i18n/localized";
import { dateTime } from "../../../lib/format";

export function AckLeg({
  leg,
  name,
  body,
  ref: reference,
  at,
  elapsed,
  state,
}: {
  leg: string;
  name: string;
  body: string;
  ref?: string;
  at?: string;
  elapsed?: string;
  /** `na`: nothing to wait for on this leg, because another party owns it. */
  state: "ok" | "pending" | "failed" | "na";
}) {
  const pending = state === "pending";
  const na = state === "na";
  const mark = { ok: "✓", pending: "·", failed: "!", na: "–" }[state];
  return (
    <div className={`leg ${state === "failed" ? "fail" : state}`}>
      <span className="lmark">{mark}</span>
      <div>
        {leg ? <div className="lroute">{leg}</div> : null}
        <div className="lname">{name}</div>
        <div className="lbody">{body}</div>
        {reference ? <div className="lref">{reference}</div> : null}
      </div>
      <div className="lwhen">
        <div className="w1">{na ? lz("domain.leg.notApplicable", "not applicable") : pending || !at ? lz("domain.leg.awaiting", "awaiting") : dateTime(at)}</div>
        <div className="w2">{na ? "" : (elapsed ?? (pending ? lz("domain.leg.noActionNeeded", "no action needed") : ""))}</div>
      </div>
    </div>
  );
}
